module.exports = __webpack_public_path__ + "static/media/koletralogo_white.8d2073ba.png";